import React from 'react'

function BankDetails(props) {




     if(!props.data || props.data.length === 0){
        return (
            <div className='text-center mt-10'>
                <h2 className='text-2xl font-bold'>No Bank Details Available</h2>
            </div>
        )
    }
    

  return (
    <div className='bankDetails-con font-mono'>

      <div className="bg-slate-50 p-4 applcnt-pro-bioData-inner-con  border-solid border-black border-[1px] rounded-lg mt-5 shadow-2xl">
        
      <h3 className="bg-blue-950 text-white  mb-3 mt-2 text-center text-3xl">
            <b> Bank Details </b>
        </h3>
        <ul>
            <li><b>Bank Name:</b> <span>{props.data.bank_name} </span></li>
            <li><b>Account Number:</b> <span> {props.data.account_number} </span></li>
            <li><b>Account Name:</b> <span>{props.data.account_name}</span></li>
            <li><b>BVN:</b> <span> {props.data.bvn_number} </span></li>
            <li><b>NIN:</b> <span> {props.data.nin_number} </span></li>
            <li><b>TIN Number:</b> <span> {props.data.tin_number} </span></li>

        </ul>

      </div>
    </div>
  ) 
}

export default BankDetails
